// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const alomomola: PokeData = {
  "id": 594,
  "name": "alomomola",
  "height": 12,
  "weight": 316,
  "base_experience": 165,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "hydro-pump",
    "protect",
    "safeguard",
    "whirlpool",
    "helping-hand",
    "wish",
    "water-sport",
    "water-pulse",
    "wake-up-slap",
    "healing-wish",
    "brine",
    "aqua-ring",
    "aqua-jet",
    "wide-guard",
    "soak",
    "heal-pulse",
    "play-nice"
  ],
  "moves": [
    "hydro-pump",
    "protect",
    "whirlpool",
    "healing-wish",
    "brine",
    "aqua-jet",
    "aqua-tail",
    "water-spout",
    "bubble",
    "life-dew",
    "rain-dance",
    "bubble-beam",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 302,
    "item": null,
    "species": [
      {
        "name": "alomomola",
        "order": 595,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 179,
    "speed": 102,
    "ability_power": 118
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
